(() => {
  const newUserRegistrationCheckBox = '.new-barbecue-reservation-user-registration-check-box'
  const editUserRegistrationCheckBox = '.edit-barbecue-reservation-user-registration-check-box'
  const editPasswordForm = '.barbecue_reservation_edit_password_form'
  const newPasswordForm = '.barbecue_reservation_new_password_form'
  const password = '.barbecue-registration-password'
  const passwordConfirmation = '.barbecue-registration-password-confirmation'

  const init = () => {
    const path = process.env.JS_BASE_URL + 'customer/barbecue/guest/new'
    if (location.pathname === path  && localStorage.getItem('initial_user_registration_modal') === null) {
      $('#barbecue-login-confirmation-modal').click();
      localStorage.setItem('initial_user_registration_modal', 'on');
    } else if (location.pathname !== path && localStorage.getItem('initial_user_registration_modal') === 'on') {
      localStorage.removeItem('initial_user_registration_modal');
    }

    $(newPasswordForm).hide();
    toggleNewPasswordForm();
    $('body').on('click', newUserRegistrationCheckBox, toggleNewPasswordForm);

    if ($(editUserRegistrationCheckBox).prop('checked')) {
      $(editPasswordForm).show();
    } else {
      $(editPasswordForm).hide();
    }
    $('body').on('click', editUserRegistrationCheckBox, toggleEditPasswordForm);
  }

  const toggleNewPasswordForm = () => {
    if ($(newUserRegistrationCheckBox).prop('checked')) {
      $(password).prop('disabled', false);
      $(passwordConfirmation).prop('disabled', false);
      $(newPasswordForm).fadeIn();
    } else {
      $(password).prop('disabled', true);
      $(passwordConfirmation).prop('disabled', true);
      $(newPasswordForm).fadeOut();
    }
  }

  const toggleEditPasswordForm = () => {
    if ($(editUserRegistrationCheckBox).prop('checked')) {
      $(password).prop('disabled', false);
      $(passwordConfirmation).prop('disabled', false);
      $(editPasswordForm).fadeIn();
    } else {
      $(password).prop('disabled', true);
      $(passwordConfirmation).prop('disabled', true);
      $(editPasswordForm).fadeOut();
    }
  }
  $(init);
})();


